export default __webpack_public_path__ + "static/android-chrome-512x512-81b7aa72ba0991a0f83a4be7e102079e.png";